// extracted by mini-css-extract-plugin
export default {"symbolLookup":"finance_stocks-widget_symbolLookup"};